function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * @file Component for a progress bar
 */
import React, { PureComponent } from 'react';
import './ProgressBar.scss';

class ProgressBar extends PureComponent {
  static getDerivedStateFromProps(_ref, state) {
    let {
      percent
    } = _ref;

    if (percent !== state.percent) {
      return {
        percent
      };
    }

    return null;
  }
  /**
   * [constructor]
   *
   * @return {ProgressBar}
   */


  constructor(props) {
    super(props);
    const {
      percent
    } = props;
    this.state = {
      percent
    };
  }
  /**
   * Renders the progress bar
   *
   * @return {void}
   */


  render() {
    const {
      percent
    } = this.state;
    const containerStyle = {
      transitionDelay: percent > 0 && percent < 100 ? '0' : '0.4s'
    };
    return React.createElement("div", {
      className: "bcu-progress-container",
      style: containerStyle
    }, React.createElement("div", {
      className: "bcu-progress",
      style: {
        width: "".concat(percent, "%")
      }
    }));
  }

}

_defineProperty(ProgressBar, "defaultProps", {
  percent: 0
});

export default ProgressBar;
//# sourceMappingURL=ProgressBar.js.map